import { useState } from "react";
import { parseProject, type Project, type Field } from "@proof/core";
import { DatasetSource } from "@proof/authoring/Datasets";
import { DynamicSourceManager } from "@proof/authoring/DynamicSources";
import { Control } from "./components";
export function ResourceMapping({
  project,
  onChange,
  notify,
}: {
  project: Project;
  onChange: (p: Project) => void;
  notify: (s: string) => void;
}) {
  const [selected, select] = useState("");
  const field =
    project.fields.find((f) => f.id === selected) || project.fields[0];
  const update = (patch: Partial<Field>) => {
    try {
      onChange(
        parseProject({
          ...project,
          fields: project.fields.map((f) =>
            f.id === field.id ? { ...f, ...patch } : f,
          ),
        }),
      );
    } catch (e) {
      notify((e as Error).message);
    }
  };
  return (
    <section className="panel padded">
      <DynamicSourceManager
        project={project}
        onChange={onChange}
        notify={notify}
      />
      <h3>Document data mapping</h3>
      <p>
        Map project variables to dataset columns, selected rows, profile fields,
        or other sources. Apply a saved dataset from Configuration → Datasets
        first. Rules and datasets in the shared library can be used across
        projects. Applied rules, visibility settings and variable bindings
        belong to this project. Save the document draft to retain them. Parts
        inherit these mappings unless explicitly overridden.
      </p>
      {field ? (
        <>
          <Control label="Mapping variable">
            <select value={field.id} onChange={(e) => select(e.target.value)}>
              {project.fields.map((f) => (
                <option key={f.id} value={f.id}>
                  {f.label} · {f.key}
                </option>
              ))}
            </select>
          </Control>
          <DatasetSource
            project={project}
            field={field}
            update={update}
            notify={notify}
          />
        </>
      ) : (
        <p className="muted">
          Create variables or apply a reusable form before configuring data
          mappings.
        </p>
      )}
    </section>
  );
}
